// Route Constants start
export const BASE_URL = "/";
export const REGISTER = "register";
export const EMAIL_VERIFICATION = "email-verification";
export const ACTIVATE_ACCOUNT = "activate-account";
export const DASHBOARD = "";
export const FORGOT_PASSWORD = "forgot-password";
export const RESET_PASSWORD = "reset-password";
export const DEACTIVATE_FORGOT_PASSWORD = "deactivate-forgot-password";
// Route Constants end

// Activate account response codes start
export const ACTIVATE_ACCOUNT_RESPONSE_CODES = {
  LINK_EXPIRED: 10001,
  INVALID_LINK: 10002,
  ACCOUNT_NOT_FOUND: 10003,
  ACCOUNT_ALREADY_VERIFIED: 10004,
  ACCOUNT_ACTIVATED_SUCCESSFULLY: 10005,
};
// Activate account response codes end

// Type of users start
export const USERS_TYPE = {
  ADMIN: 1,
  USER: 2,
  ATP_USER: 3,
};
// Type of users end

// Custom styles for react-select
export const colourStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "#F5F8FA",
    border: "none",
    boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
    color: "#464E5F",
    borderRadius: "0.375rem",
    minHeight: "44px",
    overflow: "hidden",
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
      color: "#464E5F",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#212121",
  }),
};

// Custom styles for react-select for identifier number
export const colourStylesVariant = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "#F5F8FA",
    border: "none",
    boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
    color: "#464E5F",
    borderRadius: "0.375rem 0 0 0.375rem",
    minHeight: "44px",
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
      color: "#464E5F",
      cursor: isDisabled ? "not-allowed" : "default",
      marginBottom: "8px",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#212121",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "rgba(70, 78, 95, 0.24)",
  }),
};

// Custom styles for react-select for identifier number
export const colourStylesFullWidth = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "#F5F8FA",
    border: "none",
    boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
    color: "#464E5F",
    borderRadius: "0.375rem",
    minHeight: "44px",
    textAlign: "start",
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
      color: "#464E5F",
      cursor: isDisabled ? "not-allowed" : "default",
      marginBottom: "8px",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#212121",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "rgba(70, 78, 95, 0.24)",
    display: "flex",
    justifyContent: "start",
    fontSize: "16px"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#464E5F",
  }),
};

// Custom styles for react-select for disabled inputs
export const colourStylesFullWidthVariant = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? "#D9D9D9" : "#F5F8FA",
    border: "none",
    boxShadow: isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "",
    color: "#464E5F",
    borderRadius: "0.375rem",
    minHeight: "44px",
    textAlign: "start",
    fontSize: "1rem",
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "rgba(41, 52, 143, 0.04)" : "#fff",
      color: "#464E5F",
      cursor: isDisabled ? "not-allowed" : "default",
      marginBottom: "8px",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#212121",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "rgba(70, 78, 95, 0.24)",
    display: "flex",
    justifyContent: "start",
    fontSize: "16px"
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#464E5F",
  }),
};

export const COUNTRIES = "countries";
export const STATES = "states";
export const CITIES = "cities";

export const phoneRegExp = /^\+?\d{10,15}$/;

export const colourStylesMultiSelect = {
  ...colourStyles,
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "white", // Change background color for the multi-value container
    color: "#464E5F", // Change text color for the multi-value container
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#464E5F", // Change text color for the label of the selected options
    borderLeft: "1px solid #C4CDD5",
    borderTop: "1px solid #C4CDD5",
    borderBottom: "1px solid #C4CDD5",
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px",
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#464E5F", // Color of the cross
    borderRight: "1px solid #C4CDD5",
    borderTop: "1px solid #C4CDD5",
    borderBottom: "1px solid #C4CDD5",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    ":hover": {
      backgroundColor: "#f2f3f7", // Background color on hover
      color: "#464E5F", // Cross color on hover
    },
  }),
};

export const BankNameDropList = {
  AFFIN_BANK: "Affin Bank",
  ALLIANCE_BANK_PERSONAL: "Alliance Bank (Personal)",
  AGRONET: "AGRONet",
  AMBANK: "AmBank",
  BANK_ISLAM: "Bank Islam",
  BANK_MUAMALAT: "Bank Muamalat",
  BANK_RAKYAT: "Bank Rakyat",
  BANK_OF_CHINA: "Bank Of China",
  BSN: "BSN",
  CIMB_CLICKS: "CIMB Clicks",
  HONG_LEONG_BANK: "Hong Leong Bank",
  HSBC_BANK: "HSBC Bank",
  KFH: "KFH",
  MAYBANK_2E: "Maybank2E",
  MAYBANK_2U: "Maybank2U",
  OCBC_BANK: "OCBC Bank",
  PUBLIC_BANK: "Public Bank",
  RHB_BNAK: "RHB Bank",
  STANDERD_CHARTERED: "Standard Chartered",
  UOB_BANK: "UOB Bank",
};

export const TabTypes = {
  OVERVIEW: 1,
  ATP_ANALYSIS: 2,
  TRAINING_ANALYSIS: 3,
};